import React, { useEffect } from "react";
import { reduxForm, Form } from "redux-form";

import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { deleteNavegation } from "../../actions/navegation_action";

function deleteNavegationComponent(props) {
  const { handleSubmit, deleteNavegation, data, change, type } = props;

  useEffect(() => {
    if (data._id) {
      change("_id", data._id);
    }
  }, [data]);

  const onSubmitSuspend = (data) => {
    let body = {
      navegation_id: data._id,
    };

    deleteNavegation(body);
  };

  return (
    <Form onSubmit={handleSubmit(onSubmitSuspend)}>
      <div>
        ¿Estás seguro de que deseas {type.title.toLowerCase()} la navegacion:{" "}
        <b>{data.section} </b>
        {data.lastname}?
      </div>
    </Form>
  );
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ deleteNavegation }, dispatch);

export default compose(
  withRouter,
  connect(null, mapDispatchToProps),
  reduxForm({
    form: "notificationForm",
  })
)(deleteNavegationComponent);
